module.exports = __webpack_public_path__ + "static/hiw-img3-7005a8f8a424d8a9be1a711091f5fd39.jpg";